import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import getBaseUrl from '../utils/apiUrl';
import token from '../utils/tokenAuthorization';
import {importPenilaian} from "./karyawanSlice";

const initialState = {
    listWaliKelas: [],
    listTeachers: [],
    listKelas: [],
    currentPage: 1,
    urutan: { column: 'nama', order: 'asc' },
    search: '',

    selectedTeacher: null,  // { id, nama }
    selectedKelas: null,    // { id, category }

    errors: {
        user_id: '',
        class_id: '',
    },

    isLoading: true,
    loadingStore: false,
    loadingEdit: false,
    isFormEditted: false,

    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,
};

export const getWaliKelas = createAsyncThunk('waliKelas/getWaliKelas', async ({ search } = {}, { rejectWithValue }) => {
    try {
        const response = await axios.get(getBaseUrl + '/api/wali-kelas', {
            headers: { Authorization: `Bearer ${token()}` },
            params: { search },
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const listTeachersWaliKelas = createAsyncThunk('waliKelas/listTeachers', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(getBaseUrl + '/api/wali-kelas-list-teachers', {
            headers: { Authorization: `Bearer ${token()}` },
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const listKelasWaliKelas = createAsyncThunk('waliKelas/listKelas', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(getBaseUrl + '/api/setting/classes', {
            headers: { Authorization: `Bearer ${token()}` },
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const storeWaliKelas = createAsyncThunk('waliKelas/storeWaliKelas', async ({ user_id, class_id }, { rejectWithValue }) => {
    try {
        const response = await axios.post(
            getBaseUrl + '/api/wali-kelas',
            { user_id, class_id },
            { headers: { Authorization: `Bearer ${token()}` }, timeout: 20000 }
        );
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const updateWaliKelas = createAsyncThunk('waliKelas/updateWaliKelas', async ({ id, user_id, class_id }, { rejectWithValue }) => {
    try {
        const response = await axios.put(
            getBaseUrl + `/api/wali-kelas/${id}`,
            { user_id, class_id },
            { headers: { Authorization: `Bearer ${token()}` }, timeout: 20000 }
        );
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const detailWaliKelas = createAsyncThunk('waliKelas/detailWaliKelas', async (id, { rejectWithValue }) => {
    try {
        const response = await axios.get(getBaseUrl + `/api/wali-kelas/${id}`, {
            headers: { Authorization: `Bearer ${token()}` },
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const  deleteWaliKelas = createAsyncThunk('waliKelas/deleteWaliKelas', async (id, { rejectWithValue }) => {
    try {
        const response = await axios.delete(getBaseUrl + `/api/wali-kelas/${id}`, {
            headers: { Authorization: `Bearer ${token()}` },
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled');
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
        return rejectWithValue(error.message);
    }
});

export const importWaliKelas = createAsyncThunk("walikelas/import", async (file, { rejectWithValue }) => {
    const formData = new FormData()
    formData.append('file', file)

    try {
        const response = await axios.post(
            getBaseUrl + `/api/walikelas-import`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

const waliKelasSlice = createSlice({
    name: 'waliKelas',
    initialState,
    reducers: {
        updateStateWaliKelas: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;
        },
        setSelectedTeacher: (state, action) => {
            state.selectedTeacher = action.payload;
            state.errors.user_id = '';
            state.isFormEditted = true;
        },
        setSelectedKelas: (state, action) => {
            state.selectedKelas = action.payload;
            state.errors.class_id = '';
            state.isFormEditted = true;
        },
        clearSelectedTeacher: (state) => {
            state.selectedTeacher = null;
        },
        clearSelectedKelas: (state) => {
            state.selectedKelas = null;
        },
        resetFormWaliKelas: () => initialState,
        resetTableWaliKelas: (state) => {
            state.listWaliKelas = [];
            state.isLoading = true;
        },
        showFormErrorWaliKelas: (state) => {
            if (!state.selectedTeacher) state.errors.user_id = 'Pilih guru';
            if (!state.selectedKelas) state.errors.class_id = 'Pilih kelas';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWaliKelas.pending, (state) => { state.isLoading = true; })
            .addCase(getWaliKelas.fulfilled, (state, action) => {
                state.isLoading = false;
                state.listWaliKelas = action.payload.data;
            })
            .addCase(getWaliKelas.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            })

            .addCase(listTeachersWaliKelas.fulfilled, (state, action) => {
                state.listTeachers = action.payload.data;
            })

            .addCase(listKelasWaliKelas.fulfilled, (state, action) => {
                state.listKelas = action.payload.data;
            })

            .addCase(storeWaliKelas.pending, (state) => { state.loadingStore = true; })
            .addCase(storeWaliKelas.fulfilled, (state) => {
                state.loadingStore = false;
                state.statusResApi = 'success';
                state.messageResApi = 'Wali kelas berhasil ditambahkan';
                state.isDisplayMessage = true;
            })
            .addCase(storeWaliKelas.rejected, (state, action) => {
                state.loadingStore = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            })

            .addCase(updateWaliKelas.pending, (state) => { state.loadingEdit = true; })
            .addCase(updateWaliKelas.fulfilled, (state) => {
                state.loadingEdit = false;
                state.statusResApi = 'success';
                state.messageResApi = 'Wali kelas berhasil diubah';
                state.isDisplayMessage = true;
            })
            .addCase(updateWaliKelas.rejected, (state, action) => {
                state.loadingEdit = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            })

            .addCase(detailWaliKelas.pending, (state) => { state.loadingEdit = true; })
            .addCase(detailWaliKelas.fulfilled, (state, action) => {
                state.loadingEdit = false;
                const d = action.payload.data;
                state.selectedTeacher = { id: null, nama: d.nama, niy: d.niy };
                state.selectedKelas = { id: null, category: d.kelas };
            })
            .addCase(detailWaliKelas.rejected, (state, action) => {
                state.loadingEdit = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            })

            .addCase(deleteWaliKelas.pending, (state) => { state.isLoading = true; })
            .addCase(deleteWaliKelas.fulfilled, (state) => {
                state.isLoading = false;
                state.statusResApi = 'success';
                state.messageResApi = 'Wali kelas berhasil dihapus';
                state.isDisplayMessage = true;
            })
            .addCase(deleteWaliKelas.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            })


            .addCase(importWaliKelas.pending, (state) => {
                state.loading = true
            })
            .addCase(importWaliKelas.fulfilled, (state) => {
                state.loading = false
                state.statusResApi = 'success'
                state.messageResApi = 'Karyawan berhasil di import'
                state.isDisplayMessage = true
            })
            .addCase(importWaliKelas.rejected, (state, action) => {
                state.loading = false
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })
    },
});

export const {
    updateStateWaliKelas, setSelectedTeacher, setSelectedKelas,
    clearSelectedTeacher, clearSelectedKelas, resetFormWaliKelas,
    resetTableWaliKelas, showFormErrorWaliKelas,
} = waliKelasSlice.actions;
export default waliKelasSlice.reducer;
